import { VxNode } from './parser.js';
import { iterate } from './util.js';

export type TraverseSkipFunction = (vxNode: VxNode, depth: number, index: number) => boolean;
export type TraverseTransformFunction = (vxNode: VxNode, depth: number, index: number) => VxNode;

export interface TraverseVxNodeOptions {
    depth?: number;
    index?: number;
    transform?: TraverseTransformFunction;
    skip?: TraverseSkipFunction;
}

export interface TraverseVxNodeResult {
    vxNode: VxNode;
    depth: number;
    index: number;
}

export function* traverseVxNode(vxNode: VxNode, options: TraverseVxNodeOptions = {}): IterableIterator<TraverseVxNodeResult> {
    const depth = options.depth ?? 0;
    const index = options.index ?? 0;
    const transformed = options.transform ? options.transform(vxNode, depth, index) : vxNode;
    yield { vxNode: transformed, depth, index };
    for (const [index, child] of (transformed.children ?? []).entries()) {
        if (options.skip) {
            const skipping = options.skip(child, depth, index);
            if (skipping) {
                continue;
            }
        }
        yield* traverseVxNode(child, {
            ...options,
            index,
            depth: depth + 1,
        });
    }
}

export function* traverseElements(element: Element): IterableIterator<Element> {
    if (!element) {
        return;
    }
    yield element;
    for (const child of iterate(element.children)) {
        yield* traverseElements(child);
    }
    if (element.shadowRoot) {
        for (const child of iterate(element.shadowRoot.children)) {
            yield* traverseElements(child);
        }
    }
}
